module.exports = __webpack_public_path__ + "static/media/ic_radio_off.744e99f5.svg";